<template>
  <div class="dashboard-left-card bg-light p-2 shadow-monitoring" v-if="vendorLegalDocChart">
    <div class="text-bold">Vendor Legal Document</div>
    <bar-chart :chartData="chartData" :options="chartOptions" :styles="{ height: '60%' }" />
    <div class="custom-legend">
      <div class="legend-item">
        <div class="legend-wrapper">
          <div class="flex-column">
            <div class="legend-label-wrapper">
              <div class="legend-color" :style="{ backgroundColor: chartData.datasets[0].backgroundColor }"></div>
              <div class="legend-label">Complete</div>
            </div>
            <div class="legend-label-wrapper">
              <div class="legend-color" :style="{ backgroundColor: chartData.datasets[1].backgroundColor }"></div>
              <div class="legend-label">Expired Soon</div>
            </div>
          </div>
          <div class="flex-column">
            <div class="legend-label-wrapper">
              <div class="legend-color" :style="{ backgroundColor: chartData.datasets[2].backgroundColor }"></div>
              <div class="legend-label">Expired</div>
            </div>
            <div class="legend-label-wrapper">
              <div class="legend-color" :style="{ backgroundColor: chartData.datasets[3].backgroundColor }"></div>
              <div class="legend-label">Not Complete</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="legend-item" v-for="(dataset, index) in chartData.datasets" :key="index">
          <div :style="{ backgroundColor: dataset.backgroundColor }" class="legend-color"></div>
          <div class="legend-label">{{ dataset.label }}</div>
        </div> -->
    </div>
  </div>
</template>


<script>
import numeral from 'numeral';

export default {
  components: {
    barChart: () => import('@/components/chart/dashboard/bar-chart.vue'),
  },
  data() {
    const dataByMonth = [
      [50, 40, 45, 60, 55],  // Complete color
      [10, 20, 15, 10, 5],   // Expired Soon
      [5, 10, 5, 15, 20],    // Expired
      [10, 10, 10, 5, 10]    // Not Complete
    ];

    return {
      chartData: {
        labels: ['January 2023', 'February 2023', 'March 2023', 'April 2023', 'May 2023'],
        datasets: [
          {
            label: 'Complete',
            backgroundColor: '#009933',
            data: dataByMonth[0],
          },
          {
            label: 'Expired Soon',
            backgroundColor: '#ffde59',
            data: dataByMonth[1],
          },
          {
            label: 'Expired',
            backgroundColor: '#febd59',
            data: dataByMonth[2],
          },
          {
            label: 'Not Complete',
            backgroundColor: '#ff0000',
            data: dataByMonth[3],
          },
        ],
      },
      chartOptions: {
        showDatapoints: true,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          axis: 'y',
          callbacks: {
            label: function (tooltipItem, data) {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const currentValue = tooltipItem.yLabel;
              const previousValue = dataset.data[tooltipItem.index - 1] || 0;
              const diff = currentValue - previousValue;
              let label = dataset.label || '';

              if (label) {
                label += ': ';
              }

              label += Math.round(currentValue).toLocaleString();

              if (diff > 0) {
                if (previousValue == 0) {
                  label += ' ↑' + '100 %';
                } else {
                  label += ' ↑' + (diff / previousValue * 100).toFixed(2) + '%';
                }
              } else if (diff < 0) {
                if (previousValue == 0) {
                  label += ' ↓' + '100 %';
                } else {
                  label += ' ↓' + (Math.abs(diff) / previousValue * 100).toFixed(2) + '%';
                }
              } else {
                label += '';
              }

              return label;
            },
          },
        },

        scales: {
          yAxes: [
            {
              stacked: true,
              gridLines: {
                display: false,
              },
              ticks: {
                display: true,
                beginAtZero: true,
                stepSize: 500,
              },
              scaleLabel: {
                display: true,
                labelString: 'Jumlah Vendor',
              },
            },
          ],
          xAxes: [
            {
              stacked: true,
              gridLines: {
                display: false,
              },
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Bulan',
              },
            },
          ],
        },
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            boxWidth: 10,
          },
        },
      },
    };
  },
  computed: {
    vendorLegalDocChart() {
      this.convertData()

      return true
    },
    vendorLegaLDocDetail() {
      const data = this.$store.state.monitoringStore.vendor_legal_doc

      return data
    }
  },
  methods: {
    convertData() {
      const data = this.vendorLegaLDocDetail
      let label = []
      let dataByMonth = [[], [], [], []]

      if (data && data.length > 0) {
        for (let i in data) {
          label.push(`${this.monthConverter(data[i].freeze_month)} ${data[i].freeze_year}`)
          dataByMonth[0].push(data[i].jumlah_complete_null)
          dataByMonth[1].push(data[i].jumlah_complete_exp_soon)
          dataByMonth[2].push(data[i].jumlah_complete_expired)
          dataByMonth[3].push(data[i].jumlah_not_complete)
        }
      }

      this.chartData = {
        labels: label,
        datasets: [
          {
            label: 'Complete',
            backgroundColor: '#009933',
            data: dataByMonth[0],
          },
          {
            label: 'Expired Soon',
            backgroundColor: '#ffde59',
            data: dataByMonth[1],
          },
          {
            label: 'Expired',
            backgroundColor: '#febd59',
            data: dataByMonth[2],
          },
          {
            label: 'Not Complete',
            backgroundColor: '#ff0000',
            data: dataByMonth[3],
          },
        ],
      }
    }
  },
};
</script>

<style scoped>
.custom-legend {
  display: flex;
  margin-top: 10px;
}

.legend-item {
  display: flex;
  width: 100%;
  align-items: center;
}

.legend-wrapper {
  display: flex;
  flex-direction: row;
  padding: 0px 20px;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.legend-label-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.legend-color {
  width: 10px;
  height: 10px;
  margin-right: 5px;
}

.legend-label {
  font-size: 12px;
  font-weight: 600;
}
</style>
